<template>

	<div :class="['lds-ring', { inverse }]"><div></div><div></div><div></div><div></div></div>

</template>

<script>
	export default {
		props: {
			inverse: {
				type: Boolean,
				default: false
			}
		}
	}
</script>

<style lang="scss" scoped>

	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	.lds-ring {
		display: block; position: relative; width: 64px; height: 64px;
		div {
			box-sizing: border-box; display: block; position: absolute; width: 100%; height: 100%; border: 6px solid #fff; border-radius: 50%; animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite; border-color: #FDB913 transparent transparent transparent;
			&:nth-child(1) {
				animation-delay: -0.45s;
			}
			&:nth-child(2) {
				animation-delay: -0.3s;
			}
			&:nth-child(3) {
				animation-delay: -0.15s;
			}
		}
		&.inverse div {
			border-top-color:#fff;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue